import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { IVehicleStatusPhotosForm } from "../../models/models";
import { TFunction } from "react-i18next";

type TI8n = TFunction<["network", "translation"], undefined>

const defaultValues: IVehicleStatusPhotosForm = {
    front: "",
    right: "",
    rear: "",
    left: "",
    frontSeats: "",
    rearSeats: "",
    trunk: "",
    frWheel: "",
    flWheel: "",
    rrWheel: "",
    rlWheel: "",
    additionalPhoto1: "",
    additionalPhoto2: "",
    additionalPhoto3: "",
}

const schema = (t: TI8n) =>
    yup.object().shape({
        front: yup.string().required(t("common.error.required")),
        right: yup.string().required(t("common.error.required")),
        rear: yup.string().required(t("common.error.required")),
        left: yup.string().required(t("common.error.required")),
        frontSeats: yup.string().required(t("common.error.required")),
        rearSeats: yup.string().required(t("common.error.required")),
        trunk: yup.string().required(t("common.error.required")),
        frWheel: yup.string().required(t("common.error.required")),
        flWheel: yup.string().required(t("common.error.required")),
        rrWheel: yup.string().required(t("common.error.required")),
        rlWheel: yup.string().required(t("common.error.required")),
        additionalPhoto1: yup.string().nullable(),
        additionalPhoto2: yup.string().nullable(),
        additionalPhoto3: yup.string().nullable(),
    });

export default function (t: TI8n) {
    return { defaultValues, resolver: yupResolver(schema(t)) };
}
